





























































































import { Vue, Component } from 'vue-property-decorator'
import { Button } from 'mand-mobile'
import store from '@/store'
import { getQueryString, sendMessage } from '@/lib/common-util'

@Component({ components: { [Button.name]: Button } })
export default class Result extends Vue {
  countDownTimer: any = null
  curCount: number = 1
  count: number = 3

  get isSuccess() {
    return this.$route.query.result === 'SUCCESS'
  }
  get score() {
    if (this.$route.query.result === 'SUCCESS') {
      return this.$route.query.score
    } else {
      return ''
    }
  }
  get message() {
    return this.$route.query.message
  }
  get faceImage() {
    // console.log(this.$route.query.faceImage)
    return this.$route.query.faceImage
  }
  get returnUrl() {
    const returnUrlStr: any = this.$route.query.returnUrl || ''
    return decodeURIComponent(returnUrlStr)
  }
  get failedReturnUrl() {
    const failedReturnUrl: any = this.$route.query.failedReturnUrl || ''
    return decodeURIComponent(failedReturnUrl)
  }
  get tryCount() {
    return this.$route.query.tryCount
  }
  get mobileResultPage() {
    const resultTextConStr = sessionStorage.getItem('resultTextCon') || '{}'
    const resultTextCon = JSON.parse(resultTextConStr) || {}
    let mobileResultPage = resultTextCon.mobileResultPage || {}
    return mobileResultPage || {}
  }
  get titleTexta() {
    const title = localStorage.getItem('titleText') || 'Liveness Detection'
    return title
  }
  restartHandler() {
    window.history.go(-1)
  }
  nextSuccessStep() {
    const scoreNum: number = Number(this.score)
    if (scoreNum && scoreNum > 50) {
      let url: string = ''
      if (this.returnUrl.indexOf('?') !== -1) {
        const queryStr = this.returnUrl.split('?')[1]
        const isIframe = getQueryString('isLivenessIframe', queryStr)
        if (isIframe && isIframe !== 'false') {
          sendMessage({info: 'successNext'})
          // console.log('iframeNext')
          // window.parent.postMessage({
          //   info: 'successNext',
          // }, '*')
          return
        } else {
          url = `${this.returnUrl}&successCode=${this.$route.query.result}&version=image`
        }
      } else {
        url = `${this.returnUrl}?successCode=${this.$route.query.result}&version=image`
      }
      // window.location.href = `${this.returnUrl}?successCode=${this.$route.query.result}&version=image`
      window.location.href = url
    } else {
      this.nextFailStep()
    }
  }
  nextFailStep() {
    let url: string = ''
    if (this.failedReturnUrl.indexOf('?') !== -1) {
      const queryStr = this.failedReturnUrl.split('?')[1]
      const isIframe = getQueryString('isLivenessIframe', queryStr)
      if (isIframe && isIframe !== 'false') {
        sendMessage({info: 'failedNext'})
        // window.parent.postMessage({
        //   info: 'failedNext',
        // }, '*')
        return
      } else {
        url = `${this.failedReturnUrl}&failCode=${this.$route.query.result}&message=${this.message}&version=image`
      }
    } else {
      url = `${this.failedReturnUrl}?failCode=${this.$route.query.result}&message=${this.message}&version=image`
    }
    window.location.href = url
    // window.location.href = `${this.failedReturnUrl}?failCode=${this.$route.query.result}&message=${this.message}&version=image`
  }
  countDownPromise() {
    this.resetCountDown()
    this.countDownTimer = setInterval(() => {
      this.curCount --
      if (this.curCount <= 1) {
        clearInterval(this.countDownTimer)
        this.nextSuccessStep()
      }
    }, 1000)
  }
  resetCountDown() {
    this.curCount = this.count
    clearInterval(this.countDownTimer)
    this.countDownTimer = null
  }
  async mounted() {
    const scoreNum: number = Number(this.score)
    if (this.$route.query.result === 'SUCCESS' && this.returnUrl && scoreNum && scoreNum > 50) {
      this.countDownPromise()
    }
  }
}
